import { MAIN_API_HOST } from '../_config/api';
import { getToken } from '../_utils/storage_handler';

export const HEADERS_OPTIONS = {
    'Content-Type': 'application/json'
};

export const GET_OPTIONS = {
    method: "GET",
    headers: HEADERS_OPTIONS
};

export const POST_OPTIONS = {
    method: "POST",
    headers: HEADERS_OPTIONS
};

export const PUT_OPTIONS = {
    method: "PUT",
    headers: HEADERS_OPTIONS
};

export const DELETE_OPTIONS = {
    method: "DELETE",
    headers: HEADERS_OPTIONS
};

export const sendFetch = (path, options, body=null) => {
    // Build options per request so the token is read at call time, not at module load
    const requestOptions = {
        ...options,
        headers: {
            ...options.headers,
            "Authorization": `Bearer ${getToken()}`
        }
    };
    if(body !== null) requestOptions.body = JSON.stringify(body);
    return new Promise((resolve, reject) => {
        fetch(`${MAIN_API_HOST}${path}`,requestOptions)
        .then(res => {
            // console.log("Response: " + res);
            return res.json();
        })
        .then(json => resolve(json))
        .catch(err => reject(err));
    });
}

export const handleFetch = async (path, options, body) => {
    let json = await sendFetch(path, options, body);
    if(! json.ok) throw new Error(json.error);
    return json;
}